export const translations = {
  en: {
    // Header
    phone: "📞 22261125",
    email: "info@elixirblend.com",
    
    // Hero Section
    heroTitle: "Get Your Professional Website in",
    heroTitleHighlight: "Just 10 Days!",
    heroSubtitle: "Transform your business with a stunning, mobile-responsive website that converts visitors into customers. Fill out the form and get a custom proposal within 24 hours!",
    
    // Trust Indicators
    websitesBuilt: "250+ Websites Built",
    dayDelivery: "10-Day Delivery",
    clientRetention: "87% Client Retention",
    
    // Form Section
    formTitle: "🚀 Start Your Website Project Today",
    formSubtitle: "Get a free consultation and custom proposal. No commitment required!",
    
    // Form Fields
    fullName: "Full Name",
    fullNameRequired: "Name is required",
    fullNameMinLength: "Name must be at least 2 characters",
    companyName: "Company Name",
    emailAddress: "Email Address",
    emailRequired: "Email is required",
    emailInvalid: "Invalid email address",
    phoneNumber: "Phone Number",
    websiteType: "Website Type",
    websiteTypeRequired: "Please select a website type",
    selectWebsiteType: "Select website type",
    businessWebsite: "Business Website",
    ecommerceStore: "E-commerce Store",
    portfolioPersonal: "Portfolio/Personal",
    restaurantFood: "Restaurant/Food",
    realEstate: "Real Estate",
    healthcareMedical: "Healthcare/Medical",
    educationTraining: "Education/Training",
    nonprofit: "Non-profit",
    other: "Other",
    timeline: "Timeline",
    timelineWhen: "When do you need it?",
    asap: "As soon as possible",
    withinMonth: "Within 1 month",
    twoThreeMonths: "2-3 months",
    flexible: "I'm flexible",
    projectDetails: "Project Details",
    projectDetailsRequired: "Please describe your project",
    projectDetailsMinLength: "Please provide more details (at least 20 characters)",
    projectDetailsPlaceholder: "Tell us about your project, goals, specific features you need, design preferences, etc.",
    consent: "I agree to be contacted by Elixir Blend regarding my website project inquiry.",
    consentRequired: "Please agree to be contacted",
    submitButton: "Send My Project Details",
    sending: "Sending...",
    
    // Success/Error Messages
    successTitle: "Thank you, we got your form!",
    successMessage: "We'll get back to you within 24 hours.",
    errorTitle: "Something went wrong",
    errorMessage: "Please try again or email us directly at info@elixirblend.com",
    
    // Contact Information (for desktop form)
    getStartedTitle: "Get Your Website Project Started",
    getStartedText: "Ready to transform your business with a professional website? Fill out the form and we'll get back to you within 24 hours with a personalized proposal.",
    fastResponse: "Fast Response",
    fastResponseText: "We respond to all inquiries within 24 hours",
    freeConsultation: "Free Consultation",
    freeConsultationText: "Initial consultation and project planning at no cost",
    customProposal: "Custom Proposal",
    customProposalText: "Tailored solutions based on your specific needs",
    expressService: "🚀 Express Service Available",
    expressServiceText: "Need your website fast? Our express service delivers professional websites in just 10 days!",
    
    // Testimonials
    testimonialsTitle: "What Our Clients Say",
    testimonialsSubtitle: "Real results from real businesses",
    
    // Services
    servicesTitle: "Website Types We Create",
    servicesSubtitle: "Professional solutions for every business need",
    businessWebsitesTitle: "Business Websites",
    businessWebsitesDesc: "Professional corporate sites that establish credibility and drive leads for your business",
    ecommerceStoresTitle: "E-commerce Stores",
    ecommerceStoresDesc: "Complete online stores with payment processing and inventory management systems",
    mobileFirstTitle: "Mobile-First Design",
    mobileFirstDesc: "Responsive websites that look perfect on all devices and screen sizes, optimized for mobile users",
    
    // Final CTA
    finalCtaTitle: "Ready to Transform Your Business?",
    finalCtaText: "Join 250+ successful businesses that chose Elixir Blend for their website needs. Fill out the form above and let's start building your success story!",
    finalCtaButton: "↑ Get Your Free Proposal Now",
    
    // Footer
    footerDescription: "Professional website creation services in Cyprus. Transform your business with stunning, mobile-responsive websites that drive results.",
    contactInfo: "Contact Info",
    quickStats: "Quick Stats",
    averageDelivery: "⏱️ 10-Day Average Delivery",
    starRating: "🌟 5-Star Average Rating",
    copyright: "© 2024 Elixir Blend. All rights reserved. | Professional Website Development Services in Cyprus"
  },
  
  gr: {
    // Header
    phone: "📞 22261125",
    email: "info@elixirblend.com",
    
    // Hero Section
    heroTitle: "Αποκτήστε την Επαγγελματική σας Ιστοσελίδα σε",
    heroTitleHighlight: "Μόλις 10 Ημέρες!",
    heroSubtitle: "Μεταμορφώστε την επιχείρησή σας με μια εκπληκτική, responsive ιστοσελίδα που μετατρέπει τους επισκέπτες σε πελάτες. Συμπληρώστε τη φόρμα και λάβετε μια προσαρμοσμένη πρόταση μέσα σε 24 ώρες!",
    
    // Trust Indicators
    websitesBuilt: "250+ Ιστοσελίδες Κατασκευάστηκαν",
    dayDelivery: "Παράδοση σε 10 Ημέρες",
    clientRetention: "87% Διατήρηση Πελατών",
    
    // Form Section
    formTitle: "🚀 Ξεκινήστε το Έργο της Ιστοσελίδας σας Σήμερα",
    formSubtitle: "Λάβετε δωρεάν συμβουλευτική και προσαρμοσμένη πρόταση. Χωρίς δέσμευση!",
    
    // Form Fields
    fullName: "Πλήρες Όνομα",
    fullNameRequired: "Το όνομα είναι υποχρεωτικό",
    fullNameMinLength: "Το όνομα πρέπει να έχει τουλάχιστον 2 χαρακτήρες",
    companyName: "Όνομα Εταιρείας",
    emailAddress: "Διεύθυνση Email",
    emailRequired: "Το email είναι υποχρεωτικό",
    emailInvalid: "Μη έγκυρη διεύθυνση email",
    phoneNumber: "Αριθμός Τηλεφώνου",
    websiteType: "Τύπος Ιστοσελίδας",
    websiteTypeRequired: "Παρακαλώ επιλέξτε τον τύπο ιστοσελίδας",
    selectWebsiteType: "Επιλέξτε τύπο ιστοσελίδας",
    businessWebsite: "Επιχειρηματική Ιστοσελίδα",
    ecommerceStore: "Ηλεκτρονικό Κατάστημα",
    portfolioPersonal: "Portfolio/Προσωπική",
    restaurantFood: "Εστιατόριο/Φαγητό",
    realEstate: "Ακίνητα",
    healthcareMedical: "Υγεία/Ιατρική",
    educationTraining: "Εκπαίδευση/Κατάρτιση",
    nonprofit: "Μη κερδοσκοπικό",
    other: "Άλλο",
    timeline: "Χρονοδιάγραμμα",
    timelineWhen: "Πότε το χρειάζεστε;",
    asap: "Όσο το δυνατόν πιο σύντομα",
    withinMonth: "Μέσα σε 1 μήνα",
    twoThreeMonths: "2-3 μήνες",
    flexible: "Είμαι ευέλικτος",
    projectDetails: "Λεπτομέρειες Έργου",
    projectDetailsRequired: "Παρακαλώ περιγράψτε το έργο σας",
    projectDetailsMinLength: "Παρακαλώ δώστε περισσότερες λεπτομέρειες (τουλάχιστον 20 χαρακτήρες)",
    projectDetailsPlaceholder: "Πείτε μας για το έργο σας, τους στόχους, τις συγκεκριμένες λειτουργίες που χρειάζεστε, τις προτιμήσεις σχεδιασμού κ.λπ.",
    consent: "Συμφωνώ να επικοινωνήσει μαζί μου η Elixir Blend σχετικά με το αίτημά μου για ιστοσελίδα.",
    consentRequired: "Παρακαλώ συμφωνήστε να επικοινωνήσουμε μαζί σας",
    submitButton: "Αποστολή Στοιχείων Έργου",
    sending: "Αποστολή...",
    
    // Success/Error Messages
    successTitle: "Ευχαριστούμε, λάβαμε τη φόρμα σας!",
    successMessage: "Θα επικοινωνήσουμε μαζί σας μέσα σε 24 ώρες.",
    errorTitle: "Κάτι πήγε στραβά",
    errorMessage: "Παρακαλώ δοκιμάστε ξανά ή στείλτε email απευθείας στο info@elixirblend.com",
    
    // Contact Information (for desktop form)
    getStartedTitle: "Ξεκινήστε το Έργο της Ιστοσελίδας σας",
    getStartedText: "Έτοιμοι να μεταμορφώσετε την επιχείρησή σας με μια επαγγελματική ιστοσελίδα; Συμπληρώστε τη φόρμα και θα επικοινωνήσουμε μαζί σας μέσα σε 24 ώρες με μια εξατομικευμένη πρόταση.",
    fastResponse: "Γρήγορη Απάντηση",
    fastResponseText: "Απαντάμε σε όλα τα αιτήματα μέσα σε 24 ώρες",
    freeConsultation: "Δωρεάν Συμβουλευτική",
    freeConsultationText: "Αρχική συμβουλευτική και σχεδιασμός έργου χωρίς κόστος",
    customProposal: "Προσαρμοσμένη Πρόταση",
    customProposalText: "Εξατομικευμένες λύσεις βάσει των συγκεκριμένων αναγκών σας",
    expressService: "🚀 Διαθέσιμη Express Υπηρεσία",
    expressServiceText: "Χρειάζεστε την ιστοσελίδα σας γρήγορα; Η express υπηρεσία μας παραδίδει επαγγελματικές ιστοσελίδες σε μόλις 10 ημέρες!",
    
    // Testimonials
    testimonialsTitle: "Τι Λένε οι Πελάτες μας",
    testimonialsSubtitle: "Πραγματικά αποτελέσματα από πραγματικές επιχειρήσεις",
    
    // Services
    servicesTitle: "Τύποι Ιστοσελίδων που Δημιουργούμε",
    servicesSubtitle: "Επαγγελματικές λύσεις για κάθε επιχειρηματική ανάγκη",
    businessWebsitesTitle: "Επιχειρηματικές Ιστοσελίδες",
    businessWebsitesDesc: "Επαγγελματικές εταιρικές ιστοσελίδες που εδραιώνουν την αξιοπιστία και προσελκύουν πελάτες για την επιχείρησή σας",
    ecommerceStoresTitle: "Ηλεκτρονικά Καταστήματα",
    ecommerceStoresDesc: "Ολοκληρωμένα online καταστήματα με επεξεργασία πληρωμών και συστήματα διαχείρισης αποθέματος",
    mobileFirstTitle: "Mobile-First Σχεδιασμός",
    mobileFirstDesc: "Responsive ιστοσελίδες που φαίνονται τέλειες σε όλες τις συσκευές και μεγέθη οθόνης, βελτιστοποιημένες για mobile χρήστες",
    
    // Final CTA
    finalCtaTitle: "Έτοιμοι να Μεταμορφώσετε την Επιχείρησή σας;",
    finalCtaText: "Ενταχθείτε σε 250+ επιτυχημένες επιχειρήσεις που επέλεξαν την Elixir Blend για τις ανάγκες της ιστοσελίδας τους. Συμπληρώστε τη φόρμα παραπάνω και ας ξεκινήσουμε να χτίζουμε την ιστορία επιτυχίας σας!",
    finalCtaButton: "↑ Λάβετε την Δωρεάν Πρότασή σας Τώρα",
    
    // Footer
    footerDescription: "Επαγγελματικές υπηρεσίες δημιουργίας ιστοσελίδων στην Κύπρο. Μεταμορφώστε την επιχείρησή σας με εκπληκτικές, mobile-responsive ιστοσελίδες που φέρνουν αποτελέσματα.",
    contactInfo: "Στοιχεία Επικοινωνίας",
    quickStats: "Γρήγορα Στατιστικά",
    averageDelivery: "⏱️ Μέση Παράδοση 10 Ημερών",
    starRating: "🌟 Μέσος Όρος 5 Αστέρων",
    copyright: "© 2024 Elixir Blend. Όλα τα δικαιώματα διατηρούνται. | Επαγγελματικές Υπηρεσίες Ανάπτυξης Ιστοσελίδων στην Κύπρο"
  }
}; 